export default{
    array_chunk(item,size){
        if(item.length <= 0 || size <= 0){
            return item;
        }

        let chunks = [];

        for(let i=0;i<item.length;i=i+size){
            chunks.push(item.slice(i,i+size));
        }

        return chunks
    },
    changeObjToArr(item){
        let data=[]
        for(var i in item){
            if(item[i]){
                data.push(item[i])
            }
        }
        return data
    },
    creates4(){
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    },
    createguid(){
        return (this.creates4() + this.creates4() +'-' +this.creates4() +'-' +this.creates4() +'-' +this.creates4() +'-' +this.creates4() +this.creates4() +this.creates4())
    }
}



// WEBPACK FOOTER //
// ./src/utils/conFunction.js